import PropTypes from 'prop-types'

/**
 * @typedef {Object} DriverGroupDrivers
 * @property {string} driverGroupDriverId   - ID of the assignment of a driver to a driver group
 * @property {string} driverGroupId         - ID of the driver group
 * @property {string} driverId              - ID of the driver
 */
export const driverGroupDriversPropType = PropTypes.shape({
    driverGroupDriverId: PropTypes.string,
    driverGroupId: PropTypes.string,
    driverId: PropTypes.string
})
